export default "__VITE_ASSET__DSaMYdYo__"